import {
  playConfetti as playConfettiUtil,
  playConfettiSimple as playConfettiSimpleUtil,
} from "@/utils/confetti";

/**
 * Mixin that exposes confetti helpers to Vue components.
 * Implementation lives in @/utils/confetti.js; use the mixin for this.playConfetti() / this.playConfettiSimple().
 */
export default {
  methods: {
    /**
     * Play full confetti (normal or special). Use in components via this.playConfetti(type).
     * @param {'normal'|'special'} [type='normal']
     */
    async playConfetti(type = "normal") {
      return playConfettiUtil({ type });
    },
    /**
     * Play simple 3-burst confetti. Use in components via this.playConfettiSimple(options).
     * @param {Object} [options] - { zIndex?, staggered? } — origins are hardcoded in the util
     */
    playConfettiSimple(options = {}) {
      return playConfettiSimpleUtil(options);
    },
  },
};
